import React, { useEffect, useRef, useMemo } from "react";
import { IconButton, Slider } from "rsuite";
import { PlayOutline, PauseOutline } from "@rsuite/icons";
import "../assets/css/YearSlider.css";

const YearSlider = ({ years, currentYear, setCurrentYear, playing, setPlaying }) => {
  // Keep latest years in a ref to avoid stale closures
  const yearsRef = useRef(years);
  yearsRef.current = years;

  // Map years to 0-based indices for smooth slider behavior
  const yearToIndex = useMemo(() => {
    const map = new Map();
    years.forEach((y, i) => map.set(y, i));
    return map;
  }, [years]);

  const currentIndex = yearToIndex.get(currentYear) ?? 0;

  useEffect(() => {
    if (!years || years.length === 0) return; // Guard against empty data

    if (playing) {
      const id = setInterval(() => {
        setCurrentYear(prev => {
          const currentYears = yearsRef.current;
          const idx = currentYears.indexOf(prev);

          if (idx < 0 || idx > currentYears.length - 1) {
            setPlaying(false);
            return prev; 
          }

          return currentYears[idx + 1];
        });
      }, 2000); // Adjust speed here

      return () => clearInterval(id); // Cleanup on unmount or when playing changes
    }
  }, [playing, setCurrentYear, setPlaying]);

  const handleSliderChange = (index) => {
    const selectedYear = years[index];
    if (selectedYear !== undefined) setCurrentYear(selectedYear);
  };

  return (
    <div className="year-slider-wrapper">
      <IconButton
        className="play-pause-btn"
        icon={playing ? <PauseOutline /> : <PlayOutline />}
        appearance="primary"
        onClick={() => setPlaying(prev => !prev)}
        title={playing ? "Pause timeline" : "Play timeline"}
      />
      <Slider
      className="timeline-slider"
        value={currentIndex}
        min={0}
        max={Math.max(0, years.length - 1)}
        step={1}
        progress
        graduated
        renderMark={mark => <span className="slider-mark">{years[mark]}</span>}
        onChange={handleSliderChange}
        style={{ flexGrow: 1, marginLeft: 20, marginRight: 20, marginBottom: 0 }}
        disabled={years.length === 0}
      />
    </div>
  );
};

export default YearSlider;